import {translateSupportedLanguages} from '~/utils/locale'

/**
 * Some detection codes are not in the list of supported languages, so we need to add them manually
 */
export const extraDetectionItemsEntries: Record<string, string> = {
  zh: 'Chinese',
  pt: 'Portuguese',
  sr: 'Serbian',
  es: 'Spanish',
}

export function getDetectedLanguageName(languageCode?: string) {
  if (languageCode == null) return ''

  const languageName = translateSupportedLanguages.find(
    (l) => l.code == languageCode,
  )?.name
  if (languageName) return languageName

  if (languageCode in extraDetectionItemsEntries)
    return extraDetectionItemsEntries[languageCode]

  return ''
}
